import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Profile from "../views/Profile.vue";
import Login from "../views/Login.vue"
import Registration from "../views/Registration.vue"
import Restore from "../views/Restore.vue"
import Recommend from "../views/Recommend.vue"
import Task from "../views/Task.vue"
import TaskDemo from "../views/TaskDemo.vue"
import Test from "../views/Test.vue"
import LevelStage from "../views/LevelStage.vue"
import LevelStageDemo from "../views/LevelStageDemo.vue"
import Privacy from "../views/Privacy.vue"
import Terms from "../views/Terms.vue"

Vue.use(VueRouter);

const routes = [
  { path: "/", name: "Home", component: Home },
  { path: "/recommend", name: "Recommend", component: Recommend },
  { path: "/profile", name: "Profile", component: Profile },
  { path: "/registration", name: "Registration", component: Registration },
  { path: "/login", name: "Login", component: Login },
  { path: "/restore", name: "Restore", component: Restore },
  { path: "/privacy", name: "Privacy", component: Privacy },
  { path: "/terms", name: "Terms", component: Terms },


  { path: "/levelStage", name: "LevelStage", component: LevelStage },
  { path: "/task", name: "Task", component: Task },
  { path: "/test", name: "Test", component: Test },


  { path: "/levelStageDemo/:cid/taskDemo/:lid", name: "TaskDemo", component: TaskDemo },
  { path: "/levelStageDemo/:cid", name: "LevelStageDemo", component: LevelStageDemo },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
